import { TriangleAlertIcon } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipPortal, TooltipTrigger } from '@/components/ui/tooltip';

interface LineValidationTooltipProps {
  messages: string[];
}

/** Shows the validation messages associated with a finance line item. */
export function LineValidationTooltip({ messages }: LineValidationTooltipProps) {
  if (messages.length === 0) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <TriangleAlertIcon size={16} className="text-destructive" />
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent>
          <div className="flex flex-col gap-1">
            {messages.map(message => (
              <span key={message}>{message}</span>
            ))}
          </div>
        </TooltipContent>
      </TooltipPortal>
    </Tooltip>
  );
}
